import { Component, HostListener, OnInit } from '@angular/core';
import { ClientService } from 'app/services/client-service';

@Component({
    selector: 'app-add-account-to-policy',
    templateUrl: './add-account-to-policy.component.html',
    styleUrls: ['./add-account-to-policy.component.scss']
})
export class AddAccountToPolicyComponent implements OnInit {

    show: Boolean = false;

    constructor(
        private clientService: ClientService
    ) { }

    ngOnInit() {

        this.clientService.observerAddNewAcount().subscribe((result: any) => {
            if (result !== 100) {
                this.show = true;
            }
        });

    }

    @HostListener('document:mousedown', ['$event'])
    onGlobalClick(event): void {
        if (event.target.innerHTML.includes('loading-container-cont wow fadeInUp')) {
            // clicked outside => close modal
            this.show = false;
        }
    }

    closeModal() {
        this.show = false;
    }

}
